/**
 * Drag-to-scroll for Sélection estivale.
 * Drag starts only after a movement threshold so linked product cards still navigate.
 */
(() => {
  const BIND = "data-cb-ho-summer-drag";
  const THRESHOLD_PX = 10;

  function bind(grid) {
    if (!grid || grid.getAttribute(BIND) === "1") return;
    grid.setAttribute(BIND, "1");

    let tracking = false;
    let dragging = false;
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let suppressClick = false;

    const end = () => {
      if (!tracking && !dragging) return;
      tracking = false;
      if (dragging) {
        dragging = false;
        grid.classList.remove("is-dragging");
        try {
          if (pointerId != null) grid.releasePointerCapture(pointerId);
        } catch (_) {
          /* ignore */
        }
      }
      pointerId = null;
    };

    grid.addEventListener("pointerdown", (event) => {
      if (event.button != null && event.button !== 0) return;
      tracking = true;
      dragging = false;
      suppressClick = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = grid.scrollLeft;
    });

    grid.addEventListener("pointermove", (event) => {
      if (!tracking || (pointerId != null && event.pointerId !== pointerId)) return;
      const dx = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD_PX) return;
        dragging = true;
        suppressClick = true;
        grid.classList.add("is-dragging");
        try {
          grid.setPointerCapture(pointerId);
        } catch (_) {
          /* ignore */
        }
      }
      grid.scrollLeft = startScroll - dx;
      event.preventDefault();
    });

    grid.addEventListener("pointerup", end);
    grid.addEventListener("pointercancel", end);
    grid.addEventListener("lostpointercapture", () => {
      tracking = false;
      dragging = false;
      grid.classList.remove("is-dragging");
      pointerId = null;
    });

    grid.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll(".cb-ho-summer__grid").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:reorder", scan);
})();
